import React from 'react';
import { Grid } from 'semantic-ui-react';
import { useResponsive } from 'ahooks';

const ContentGrid: React.FC<{ className?: string }> = ({
  children,
  className,
}) => {
  const screen = useResponsive();

  return (
    <Grid columns={1} centered className={`py-24 ${className || ''}`}>
      <Grid.Column className={`empty-hidden`} width={!screen.lg ? 16 : 14}>
        {children}
      </Grid.Column>
    </Grid>
  );
};

export default ContentGrid;
